import { render, staticRenderFns } from "./Tunai.vue?vue&type=template&id=bc97d6ac&scoped=true"
import script from "./Tunai.vue?vue&type=script&lang=js"
export * from "./Tunai.vue?vue&type=script&lang=js"
import style0 from "./Tunai.vue?vue&type=style&index=0&id=bc97d6ac&prod&lang=scss"
import style1 from "./Tunai.vue?vue&type=style&index=1&id=bc97d6ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc97d6ac",
  null
  
)

export default component.exports